import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        B-105, Sivanta-1,The Business Park,<br /> Pitamnagar Ellisbridge, Ahmedabad-380006,<br /> Gujarat, India
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        <a href='tel:7935028248'>7935028248</a>
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        <a href="mailto:info@celbionhealthcare.com">info@celbionhealthcare.com</a>
      </li>
    </ul>
  );
}
